import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Home from "./pages/Home";
import SevenReasons from "./pages/SevenReasons";
import EyeStrainRelief from "./pages/EyeStrainRelief";
import DeepSleep from "./pages/DeepSleep";
import FiveReasonsEyeMask from "./pages/FiveReasonsEyeMask";
import SteamEyeMask from "./pages/SteamEyeMask";

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/7-reasons" element={<SevenReasons />} />
            <Route path="/eye-strain-relief" element={<EyeStrainRelief />} />
            <Route path="/deep-sleep" element={<DeepSleep />} />
            <Route path="/5-reasons-eye-mask" element={<FiveReasonsEyeMask />} />
            <Route path="/steam-eye-mask" element={<SteamEyeMask />} />
          </Routes>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
